<script setup>
    import { ref } from 'vue';
    import { useSpotStore } from '@/stores/SpotStore';
    import { useUserStore } from '@/stores/UserStore';
    import { useCompleteReportStore } from '@/stores/CompleteReportStore';
    import { useMediaQuery } from '@/composables/useMediaQuery';
    import SpotHeaderTitle from '@/components/SpotHeaderTitle.vue';
    import SpotHeaderStatusMessage from '@/components/SpotHeaderStatusMessage.vue';
    import SpotHeaderSpotMessage from '@/components/SpotHeaderSpotMessage.vue';
    import SpotHeaderPrimaryActionList from '@/components/SpotHeaderPrimaryActionList.vue';
    import SpotHeaderActionMenuPopup from '@/components/SpotHeaderActionMenuPopup.vue';
    import CompleteReportHeaderSecondaryActions from '@/components/CompleteReportHeaderSecondaryActions.vue';
    import ModalSaveSpotToProfile from '@/components/ModalSaveSpotToProfile.vue';

    const spotStore = useSpotStore();
    const userStore = useUserStore();
    const completeReportStore = useCompleteReportStore();

    const isDesktop = useMediaQuery('(min-width: 840px)');

    const headerButtons = ['favorite', 'map', 'alerts', 'widgets'];  
    
    const showProfileModal = ref(false);

    function handleShowProfileModal() {
      showProfileModal.value = true;
    }
</script>
<template>
    <header class="jwx-page-header">
      <div class="jwx-page-header__main-content jwx-page-block jwx-page-block--padding-sm">
        <SpotHeaderTitle
          :spot="spotStore.spot"
          :isNowcastingSpot="spotStore.isNowcast"
        />
        <SpotHeaderStatusMessage :statusMessage="spotStore.statusMessage" />
  
        <SpotHeaderPrimaryActionList
          v-if="isDesktop"
          @update:showProfileModal="handleShowProfileModal"
          :buttons="headerButtons"
        />

        <SpotHeaderActionMenuPopup v-else>
          <template #menu-content>
            <SpotHeaderPrimaryActionList
              @update:showProfileModal="handleShowProfileModal"
              :buttons="headerButtons"
            />
            <CompleteReportHeaderSecondaryActions
              v-if="userStore.nonTrialMemberLevel > -1"
              v-model:showSettingsModal="completeReportStore.showSettingsModal"
            />
          </template>
        </SpotHeaderActionMenuPopup>

        <SpotHeaderSpotMessage :spotMessage="spotStore.spotMessage" />
      </div>

      <CompleteReportHeaderSecondaryActions
        v-if="isDesktop && userStore.nonTrialMemberLevel > -1"
        v-model:showSettingsModal="completeReportStore.showSettingsModal"
      />
    </header>

    <ModalSaveSpotToProfile
      v-model:showProfileModal="showProfileModal"
      v-if="showProfileModal"
      :profiles="userStore.userProfiles.profiles"
    />
</template>